export const GENDERS = {
    Female: 'Female',
    Male: 'Male',
    Other: 'Other',
} as const;
export type GenderTypes = (typeof GENDERS)[keyof typeof GENDERS];

export const PROVIDERS = {
    Local: 'Local',
    Google: 'Google',
    Apple: 'Apple',
} as const;
export type Providers = (typeof PROVIDERS)[keyof typeof PROVIDERS];

export const ID_VERIFICATION_PROVIDERS = {
    Stripe: 'Stripe',
    Persona: 'Persona',
} as const;
export type IdVerificationProviders =
    (typeof ID_VERIFICATION_PROVIDERS)[keyof typeof ID_VERIFICATION_PROVIDERS];
